import app from '../app.jsx'

// Event filters
const _teamFilter = function (data) {
  const teamId = app.teamId
  if (data && data.teamId === teamId) {
    return true
  }

  return false
}

const _objectFilter = function (data, objectId, variableId) {
  if (
    _teamFilter(data) &&
    data[variableId] !== undefined &&
    data[variableId] === objectId
  ) {
    return true
  }

  return false
}

const eventfilters = {
  teamFilter: _teamFilter,
  objectFilter: _objectFilter
}

export default eventfilters
